import ReactModal from 'react-modal';

import VARIANTS from '../../../constants/variants';
import { ICONS } from '../../../icons/icon';
import type { FCC } from '../../../types/common';
import IconButton from '../../../ui/icon_button/icon_button';
import { fullscreenElementOrBody } from '../../../utils/fullscreen_element_or_body';

import styles from './small_panels.module.css';

if (typeof window !== 'undefined') {
  const element: HTMLElement =
    document.querySelector('#root') || document.createElement('div');
  ReactModal.setAppElement(element);
}

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
};

const SmallPanelsModal: FCC<Props> = (props) => (
  <ReactModal
    isOpen={props.isOpen}
    onRequestClose={props.onRequestClose}
    closeTimeoutMS={300}
    className={{
      base: styles.modal,
      afterOpen: styles.modalAfterOpen,
      beforeClose: styles.modalBeforeClose,
    }}
    overlayClassName={styles.overlay}
    portalClassName="modal_portal"
    bodyOpenClassName="modal_body_open"
    htmlOpenClassName="modal_html_open"
    parentSelector={fullscreenElementOrBody}
  >
    <IconButton
      icon={ICONS.CrossMark}
      className={styles.close_button}
      onClick={props.onRequestClose}
      variant={VARIANTS.WHITE}
    />
    {props.children}
  </ReactModal>
);

export default SmallPanelsModal;
